export const ROLE_ADMIN = ['100'];
export const ROLE_PROPERTY_REGISTER = ['101', '102']; // จัดเก็บทรัพย์สิน
export const ROLE_TAXMAP = ['103', '104'];             // แผนที่ภาษี
export const ROLE_WELFARE = ['200'];                   // สวัสดิการ
export const ROLE_REVENUE = ['300', '301'];            // พัฒนารายได้ / ค่าขยะ
export const ROLE_PUBLIC_WORKS = ['400', '401'];       // กองช่าง

// สิทธิ์สำหรับกลุ่มงานสำรวจ/แผนที่ภาษี
export const SURVEY_NAV_ROLES = [
  ...ROLE_ADMIN,
  ...ROLE_TAXMAP,
  ...ROLE_PROPERTY_REGISTER,
];

// รวมทุกสิทธิ์ในระบบ
export const ROLE_ANY = [
  ...ROLE_ADMIN,
  ...ROLE_TAXMAP,
  ...ROLE_PROPERTY_REGISTER,
  ...ROLE_WELFARE,
  ...ROLE_REVENUE,
  ...ROLE_PUBLIC_WORKS,
];